export const routes = {
  home: '/',
  history: '/history/:date?',
  settings: '/settings',
}
